import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import ReelGroup from "../../../vendor_core/core/src/views/ReelGroup";
import BangUp from "../../../vendor_core/core/src/utils/BangUp";
import CommandManager from "../../../vendor_core/core/src/commands/CommandManager";
import { Commands } from "../../../vendor_core/core/src/commands/CommandEnum";
import { Tween } from "../../../vendor_core/core/src/Tween";
import PromiseHelpers from "../../../vendor_core/core/src/utils/PromiseHelpers";
import {
    Zoom,
    FadeOut
} from "../../../vendor_core/core/src/transitions/TransitionAnimations";
import { Ease } from "../../../vendor_core/core/src/Ease";
import TextField from '../../../vendor_core/core/src/views/components/TextField';
import Utils from '../Utils';
import SoundController from '../../../vendor_core/core/src/utils/SoundController';
import ShowWinState from "../../../vendor_core/core/src/states/ShowWinState";
import BetModel from "../../../vendor_core/core/src/model/BetModel";
import { Point } from "pixi.js";

export default class TRWShowWinState extends ShowWinState {
    private animPositions: any[] = [];
    private animCounter: number = 0;

    protected get haveBangup(): boolean {
        return SpinModel.getCurrentWin() >= (3 * BetModel.totalBet);
    }

    public enter() {
        Utils.prepareTWScene();
        super.enter();
    }

    public displayWin(): void {
        const tumbleScene = ViewManager.getLayer("ThumbleWinCounter").getCurrentScene();
        const winTF = tumbleScene.sceneMoneyFields.get("tw_total");
        const twPlate = tumbleScene.groups.get("tw_plate");
        twPlate.visible = true;
        const cascade = SpinModel.cascades[SpinModel.cascadeIndex];

        if (cascade) {
            // Update tumble wins only when in cascade (not bonus trigger)
            const winBangUp = new BangUp();
            winBangUp.startBangup(
                cascade.tempWinAmount - cascade.winAmount,
                cascade.tempWinAmount,
                1.4,
                {},
                (val) => winTF.value = val
            );
            // CommandManager.execute(Commands.UPDATE_CASCADE_HISTORY);
        }

        SpinModel.tempWinAmount = cascade.accumulatedWin;

        const reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as ReelGroup;
        const reels = Array.from(Array(reelGroup.reels.length).keys());
        const result = SpinModel.getFinalSymsForReels(reels);
        reelGroup.showFinalSymbols(result);

        CommandManager.execute(Commands.UPDATE_TEMP_WIN);


        const winsData = SpinModel.getCurrentWinsData();
        this.animPositions = [];

        let promises: Promise<boolean>[] = [];
        SoundController.playSound("win_medium");
        winsData.forEach((win) => {

            this.animCounter++;
            promises.push(
                this.playWinCountersAnim(win)
            )
        });

        PromiseHelpers.combineParallel(promises)

        super.displayWin();
    }

    public exit(): void {
        this.animCounter = 0;
        super.exit();
    }

    private playWinCountersAnim(winData): Promise<boolean> {

        return new Promise<boolean>(async (res) => {

            const possIndex = this.definePosition(winData.coordinates);
            this.animPositions.push(winData.coordinates[possIndex]);
            let symbol = ReelGroup.instance.winSymbolsView.getAnimAtReelCell(winData.coordinates[possIndex].x-1, winData.coordinates[possIndex].y-1);
            let symbolOverlay = symbol.showTextOverlay(
                    5,
                    (winData.creditsWon).toFixed(2)
                    // (BetModel.currency.symbol + (winData.creditsWon / 100).toFixed(2))
                ) as TextField;

            // this is done because the overlay shouldn't disappear with the SymbolAnimation
            const globalTextPositions: Point = symbolOverlay.getGlobalPosition();
            const convertedCoordinates: Point = symbolOverlay.parent.parent.parent.toLocal(globalTextPositions);
            symbolOverlay.position.set(convertedCoordinates.x, convertedCoordinates.y);

            symbolOverlay.parent.parent.parent.addChild(symbolOverlay);
            symbolOverlay.zIndex = 40 + this.animCounter;

            await this.showUp(symbolOverlay);
            if ((winData.coordinates[possIndex].y - 1) < 1) {
                await this.flyDown(symbolOverlay);
            } else {
                await this.flyUp(symbolOverlay);
            }
            symbolOverlay.zIndex = 0;
            res(true);
        });
    }

    private definePosition(coordinates: {x:number, y:number}[]): number {
        // these are the reels we want to show profit on by priority
        const reelsPriority: number[] = [3, 4, 2, 5, 1, 6];
        let symIdx: number = 0;

        for(let i = 0; i < reelsPriority.length; i++) {
            let winRow = 0;
            for(let j = 0; j < coordinates.length; j++) {
                // if the symbol "X" position matches with our desired position of the reels
                if (coordinates[j].x == reelsPriority[i]) {

                    // this is done so that winning values don't overlap
                    if (this.animPositions[0]) {
                        if (coordinates[j].y == this.animPositions[0].y ||
                            this.animPositions[0].y == 1 && coordinates[j].y == 2 ||
                            this.animPositions[0].y == 2 && coordinates[j].y == 1
                        ) continue;
                    }
                    if (this.animPositions[1]) {
                        if (coordinates[j].y == this.animPositions[1].y ||
                            this.animPositions[1].y == 1 && coordinates[j].y == 2 ||
                            this.animPositions[1].y == 2 && coordinates[j].y == 1
                        ) continue;
                    }

                    symIdx = j;
                    winRow++;
                    if (winRow < 3 &&
                        coordinates[j+1] &&
                        coordinates[j+1].x == reelsPriority[i]) {
                            continue;
                    } else {
                        break;
                    }
                }
            };
            if (symIdx != 0) {
                break;
            }
        };

        return symIdx;
    }

    private showUp(counter: TextField) {
        Zoom(counter, 0.1, 2.8, 0.2, 0, Ease.BackIn2);
        return PromiseHelpers.getFakePromise(0.3);
    }

    private flyUp(counter: TextField) {
        Tween.to(counter, 1.7, { y: counter.y - counter.height / 5, ease: Ease.Power3Out });
        Tween.to(counter, 1, {
            alpha: 0,
            delay: 1.4,
            ease: Ease.Power4In,
            onComplete: () => {
                counter.destroy();
            }
        })
        return PromiseHelpers.getFakePromise(1);
    }

    private flyDown(counter: TextField) {
        Tween.to(counter, 1.7, { y: counter.y + counter.height / 3, ease: Ease.Power3Out });
        Tween.to(counter, 1, {
            alpha: 0,
            delay: 1.4,
            ease: Ease.Power4In,
            onComplete: () => {
                counter.destroy();
            }
        })
        return PromiseHelpers.getFakePromise(1);
    }
}
